{
  "version": 1,
  "asset_id": "6a96a188-bec3-4469-8a55-9f53a25cf670",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/6a96a188-bec3-4469-8a55-9f53a25cf670/gallery-4.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/6a96a188-bec3-4469-8a55-9f53a25cf670/gallery-4.jpeg",
  "original_filename": "gallery-4.jpeg",
  "size": 1730456,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:37Z"
}
